import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { useAppSelector } from '../../../Reducers/store';
import ClientApi from '../../../Api/ClientApi';
import { Job } from '../../../Models/Job';
import ClientJobListTable from './ClientJobListTable';

export default function ClientJobList({ clientId }: { clientId: number }) {
  const { userModel } = useAppSelector((state) => state.user);
  const [clientJobData, setclientJobData] = useState<Job[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getClientJobList = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ClientApi.getClientJobList(clientId)
          .then((res) => {
            setclientJobData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  }, [clientId]);

  useEffect(() => {
    getClientJobList();
  }, [getClientJobList]);

  return (
    <>
      <div className='w-full'>
        <div className='w-full p-4'>
          <div className='relative'>
            {isLoading && <Loader />}
            <ClientJobListTable data={clientJobData} />
          </div>
        </div>
      </div>
    </>
  );
}
